import { render, staticRenderFns } from "./DetailsMaterialForm.vue?vue&type=template&id=3ce407ea&"
import script from "./DetailsMaterialForm.vue?vue&type=script&lang=ts&"
export * from "./DetailsMaterialForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports